import { styled } from '@mui/system';
import { Skeleton, TextField, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { TopContainer as BaseTopContainer } from '../styles';

export const SubTitle = styled('div')({
  fontWeight: 500,
  fontSize: 13,
  color: '#757475',
});

export const TitleContainer = styled(BaseTopContainer)({
  justifyContent: 'flex-start',
  gap: 10,
});

export const InputsContainer = styled('form')({
  padding: '12px 15px',
  borderBottom: '1px solid #eaeaea',
});

export const InputsTitle = styled(Typography)({
  fontWeight: 600,
  fontSize: 13,
  color: '#414046',
  marginBottom: 12,
});

export const InputsRow = styled('div')({
  display: 'flex',
  gap: 10,
});

export const DosageInput = styled(TextField)({
  flex: 1,
});

export const FrequencyInput = styled(TextField)({
  flex: 1,
});

export const RemainingContainer = styled('div')({
  padding: '12px 15px',
});

export const RemainingTitle = styled(InputsTitle)``;

export const RemainingChipContainer = styled('div')<{
  type: 'check' | 'warning';
}>(({ type }) => ({
  display: 'flex',
  alignItems: 'center',
  background: type === 'check' ? '#eef6ed' : '#FFF1C6',
  borderRadius: 23,
  gap: 4,
  padding: '2px 4px',
  width: 'fit-content',
}));

export const RemainingChipIcon = styled('div')<{ type: 'check' | 'warning' }>(
  ({ type }) => ({
    width: 15,
    height: 15,
    background: type === 'check' ? '#00a650' : '#f8d76d',
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
);

export const RemainingChipText = styled(Typography)<{
  type: 'check' | 'warning';
}>(({ type }) => ({
  fontWeight: 500,
  fontSize: 13,
  color: type === 'check' ? '#284525' : '#414046',
}));

export const StyledCheckIcon = styled(CheckIcon)({
  color: 'white',
  fontSize: 14,
});

export const StyledPriorityHighIcon = styled(PriorityHighIcon)({
  color: 'white',
  fontSize: 13,
});

export const InlineSkeleton = styled(Skeleton)({
  display: 'inline-block',
});
